function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}export var GroceryListService = /*#__PURE__*/function () {GroceryListService.$inject = ["$q", "MealPlanModel", "MeasurementSystem", "UserService", "MealPlanService", "FoodModel"];
  function GroceryListService($q, MealPlanModel, MeasurementSystem, UserService, MealPlanService, FoodModel) {
    "ngInject";_classCallCheck(this, GroceryListService);
    this.$q = $q;
    this.MealPlanModel = MealPlanModel;
    this.FoodModel = FoodModel;
    this.MeasurementSystem = MeasurementSystem;
    this.UserService = UserService;
    this.MealPlanService = MealPlanService;
    this.currentWeekNumber = this.UserService.data.last_checkin.week_number;
    this.cache = {};
    this.groceryItemsTemplate = {
      'meat': {
        calories: 0,
        fats: 0,
        proteins: 0,
        carbohydrates: 0,
        name: 'Meat' },

      'bread': {
        calories: 0,
        fats: 0,
        proteins: 0,
        carbohydrates: 0,
        name: 'Bread' },

      'fruit': {
        calories: 0,
        fats: 0,
        proteins: 0,
        carbohydrates: 0,
        name: 'Fruits' },

      'vegetable': {
        calories: 0,
        fats: 0,
        proteins: 0,
        carbohydrates: 0,
        name: 'Vegetables' },

      'extra': {
        calories: 0,
        fats: 0,
        proteins: 0,
        carbohydrates: 0,
        name: 'Extra' },

      'free': {
        calories: 0,
        fats: 0,
        proteins: 0,
        carbohydrates: 0,
        name: 'Free' },

      'additional': {
        calories: 0,
        fats: 0,
        proteins: 0,
        carbohydrates: 0,
        name: 'Additional' } };


  }_createClass(GroceryListService, [{ key: "setCacheFromFirebase", value: function setCacheFromFirebase(

    weekNumber, data) {
      this.cache[weekNumber] = data;
    } }, { key: "fetch", value: function fetch(

    weekNumber, from_cache) {var _this = this;
      if (from_cache && this.cache[weekNumber]) {
        return this.$q.resolve(this.cache[weekNumber]);
      }
      var reqs = [];
      if (this.currentWeekNumber == weekNumber) {
        reqs = [
        this.MealPlanService.fetch(),
        this.MeasurementSystem.getMeasurementSystem(),
        this.FoodModel.query()];

      } else if (this.currentWeekNumber + 1 == weekNumber) {
        reqs = [
        this.MealPlanService.fetch({ week_number: weekNumber }),
        this.MeasurementSystem.getMeasurementSystem(),
        this.FoodModel.query()];

      } else
      {
        reqs = [
        this.MealPlanModel.query({ week_number: weekNumber }),
        this.MeasurementSystem.getMeasurementSystem(),
        this.FoodModel.query()];

      }
      return this.$q.all(reqs).
      then(function (res) {
        console.warn('GroceryListService fetch then', res[0]);
        _this.measurementSystem = res[1];
        _this.foods = _this.setFoodToObj(res[2]);
        _this.cache[weekNumber] = _this.parseData(res[0]);
        return _this.cache[weekNumber];
      }).
      catch(function (err) {
        console.warn('GroceryListService fetch catch', err);
      });
    } }, { key: "setFoodToObj", value: function setFoodToObj(

    foods) {
      var foodsObj = {};
      for (var i = 0; i < foods.length; i++) {
        var food = foods[i];
        foodsObj[food.name] = food;
      }
      return foodsObj;
    } }, { key: "calculateItemsInCategory", value: function calculateItemsInCategory(

    groceryItemsInCategory) {
      groceryItemsInCategory.calories = 0;
      groceryItemsInCategory.fats = 0;
      groceryItemsInCategory.proteins = 0;
      groceryItemsInCategory.carbohydrates = 0;
      for (var key in groceryItemsInCategory) {
        if (groceryItemsInCategory.hasOwnProperty(key) && ['calories', 'fats', 'proteins', 'carbohydrates', 'name'].indexOf(key) == -1) {
          groceryItemsInCategory.calories += Number(groceryItemsInCategory[key].calories);
          groceryItemsInCategory.fats += Number(groceryItemsInCategory[key].fats);
          groceryItemsInCategory.proteins += Number(groceryItemsInCategory[key].proteins);
          groceryItemsInCategory.carbohydrates += Number(groceryItemsInCategory[key].carbohydrates);
        }
      }
      return groceryItemsInCategory;
    } }, { key: "addItem", value: function addItem(

    weekNumber, meal_item) {
      var _meal_item = angular.copy(meal_item);
      _meal_item.category = 'additional';
      if (this.cache[weekNumber][_meal_item.category].hasOwnProperty(_meal_item.name)) {
        this.cache[weekNumber][_meal_item.category][_meal_item.name].exchanges += Number(_meal_item.exchanges);
      } else
      {
        this.cache[weekNumber][_meal_item.category][_meal_item.name] = this.setGroceryItem(_meal_item);
      }
      this.cache[weekNumber][_meal_item.category].calories += Number(_meal_item.calories);
      this.cache[weekNumber][_meal_item.category].fats += Number(_meal_item.fats);
      this.cache[weekNumber][_meal_item.category].proteins += Number(_meal_item.proteins);
      this.cache[weekNumber][_meal_item.category].carbohydrates += Number(_meal_item.carbohydrates);
      this.cache[weekNumber][_meal_item.category][_meal_item.name].calories += Number(_meal_item.calories);
      this.cache[weekNumber][_meal_item.category][_meal_item.name].fats += Number(_meal_item.fats);
      this.cache[weekNumber][_meal_item.category][_meal_item.name].proteins += Number(_meal_item.proteins);
      this.cache[weekNumber][_meal_item.category][_meal_item.name].carbohydrates += Number(_meal_item.carbohydrates);
      return this.cache[weekNumber];
    } }, { key: "setGroceryItem", value: function setGroceryItem(

    mealItem) {
      var food = this.foods[mealItem.name];
      var amazon_code = food ? food.amazon_code : null;
      return {
        calories: 0,
        fats: 0,
        proteins: 0,
        carbohydrates: 0,
        amount: mealItem.amount ? Number(mealItem.amount) : Number(mealItem.exchanges) * Number(mealItem.portion),
        amount_si: mealItem.amount_si ? Number(mealItem.amount_si) : Number(mealItem.exchanges) * Number(mealItem.portion_si),
        name: mealItem.name,
        exchanges: mealItem.exchanges,
        portion: mealItem.portion,
        portion_si: mealItem.portion_si,
        unit: mealItem.unit,
        unit_si: mealItem.unit_si,
        id: mealItem.id,
        category: mealItem.category,
        amazon_code: amazon_code };

    } }, { key: "parseData", value: function parseData(

    mealPlan) {
      var groceryItems = angular.copy(this.groceryItemsTemplate);

      for (var i = 0; i < mealPlan.days.length; i++) {
        var day = mealPlan.days[i];
        for (var j = 0; j < day.meals.length; j++) {
          var meal = day.meals[j];
          if (!(meal.logged || meal.skipped)) {
            for (var k = 0; k < meal.meal_items.length; k++) {
              var meal_item = meal.meal_items[k];
              if (!meal_item.deleted) {
                if (!groceryItems[meal_item.category]) {
                  console.warn("category not found: ".concat(meal_item.category));
                  continue;
                }
                if (this.measurementSystem == 'US') {
                  if (groceryItems[meal_item.category].hasOwnProperty(meal_item.name)) {
                    groceryItems[meal_item.category][meal_item.name].exchanges += Number(meal_item.exchanges);
                    groceryItems[meal_item.category][meal_item.name].amount += meal_item.amount ? Number(meal_item.amount) : Number(meal_item.exchanges) * Number(meal_item.portion);
                  } else
                  {
                    groceryItems[meal_item.category][meal_item.name] = this.setGroceryItem(meal_item);
                  }
                } else
                {
                  if (groceryItems[meal_item.category].hasOwnProperty(meal_item.name)) {
                    groceryItems[meal_item.category][meal_item.name].exchanges += Number(meal_item.exchanges);
                    groceryItems[meal_item.category][meal_item.name].amount_si += meal_item.amount_si ? Number(meal_item.amount_si) : Number(meal_item.exchanges) * Number(meal_item.portion_si);
                  } else
                  {
                    groceryItems[meal_item.category][meal_item.name] = this.setGroceryItem(meal_item);
                  }
                }
                groceryItems[meal_item.category].calories += Number(meal_item.calories);
                groceryItems[meal_item.category].fats += Number(meal_item.fats);
                groceryItems[meal_item.category].proteins += Number(meal_item.proteins);
                groceryItems[meal_item.category].carbohydrates += Number(meal_item.carbohydrates);
                groceryItems[meal_item.category][meal_item.name].calories += Number(meal_item.calories);
                groceryItems[meal_item.category][meal_item.name].fats += Number(meal_item.fats);
                groceryItems[meal_item.category][meal_item.name].proteins += Number(meal_item.proteins);
                groceryItems[meal_item.category][meal_item.name].carbohydrates += Number(meal_item.carbohydrates);
              }
            }
          }
        }
      }

      return angular.copy(groceryItems);
    } }]);return GroceryListService;}();